export default __webpack_public_path__ + "static/media/tofy.5eb36b49.png";